import React from "react";

const SVG = ({
  style = {},
  fill = "none",
  stroke = "#000",
  width = "24px",
  height = "24px",
  className = "",
  viewBox = "0 0 24 24"
}) => (
  <svg
    width={width}
    height={height}
    style={style}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <rect x="3" y="4" width="18" height="17" rx="2" stroke={stroke} strokeWidth="1.5" />
    <path d="M3 9H21" stroke={stroke} strokeWidth="1.5" />
    <path d="M8 2V6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M16 2V6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default SVG;
